import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
  useParams,
  useNavigate
} from "react-router-dom";

export default function EditTicket() {

  const { id } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(true);

  const [form, setForm] = useState({
    subject: "",
    description: "",
    category: "",
    priority: "Medium",
  });

  // LOAD TICKET
  useEffect(() => {

    axios
      .get(
        `https://support.g6techcare.com/api/ticket/${id}`
      )
      .then((res) => {

        setForm({
          subject: res.data.subject || "",
          description:
            res.data.description || "",
          category:
            res.data.category || "",
          priority:
            res.data.priority || "Medium",
        });

        setLoading(false);
      });

  }, [id]);

  // UPDATE INPUT
  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // UPDATE TICKET
  const handleUpdate = async () => {

    try {

      await axios.put(
        `https://support.g6techcare.com/api/ticket/${id}`,
        form
      );

      alert("Ticket Updated Successfully");

      navigate(`/ticket/${id}`);

    } catch (err) {

      console.log(err);

      alert("Update Failed");
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (

    <div className="edit-ticket-page">

      <div className="edit-card">

        <div className="edit-header">

          <div>
            <h2>Edit Ticket</h2>
            <p>
              Ticket #{id}
            </p>
          </div>

        </div>

        {/* SUBJECT */}
        <div className="form-group">

          <label>
            Subject
          </label>

          <input
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            placeholder="Enter subject"
          />

        </div>

        {/* DESCRIPTION */}
        <div className="form-group">

          <label>
            Description
          </label>

          <textarea
            rows="6"
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder="Describe issue"
          />

        </div>

        {/* GRID */}
        <div className="grid-2">

          {/* CATEGORY */}
          <div className="form-group">

            <label>
              Category
            </label>

            <select
              name="category"
              value={form.category}
              onChange={handleChange}
            >

              <option value="">
                Select
              </option>

              <option value="System Slow">
                System Slow
              </option>

              <option value="Virus">
                Virus
              </option>

              <option value="Network Issue">
                Network Issue
              </option>

            </select>

          </div>
          {/* PRIORITY - READ ONLY */}
         <div className="form-group">
          <label>Priority</label>

          <input
    type="text"
    name="priority"
    value={form.priority}
    readOnly
    className="input-readonly"
  />
</div>

        </div>

        {/* BUTTONS */}
        <div className="btn-row">

          <button
            className="cancel-btn"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>

          <button
            className="update-btn"
            onClick={handleUpdate}
          >
            Update Ticket
          </button>

        </div>

      </div>

    </div>

  );
}